<template>
  <div class="team text-center">
    <div class="heading">
      <h3>Robotics Live Forum</h3>
    </div>
    <div class="links">
      <a class="arts"
         style="padding: 20px 0px;"
         v-for="path in user.paths" :key="path.id">{{ path.name.toUpperCase() }} <br> Level: {{ path.level }}
      </a>
    </div>

    <div class="notifications" v-if="notifications.length">
      <div class="card" :class="[index === 0 ? 'aarrttc' : index === 1 ? 'rroobbc' : 'mmuuiic']"
           :ref="'notification' + notification.id" v-for="(notification, index) in notifications"
           :key="notification.id"
           style="min-height: 245px;">
        <div class="close" @click.prevent="close(notification.id)">+</div>
        <!--<a href="#" class="replay">Reply</a>-->
        <div class="row g-0">
          <div class="col-md-3" v-if="notification.user && notification.user.picture && notification.user.picture.url">
            <img :src="url + '/uploads/pictures/' + notification.user.picture.url"
                 class="img-fluid rounded-start"
                 alt="team member">
          </div>
          <div class="col-md-9">
            <div class="card-body">
              <h6>{{ formatDate(notification.createdAt) }}</h6>
              <h5 class="card-title">{{ notification.user.firstName }} {{ notification.user.familyName }}</h5>
              <p class="card-text" v-html="notification.text"></p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  mounted() {
    this.$store.dispatch('auth/getNotifications');
  },
  data() {
    return {
      url: process.env.VUE_APP_ROOT_IMAGES_API,
    }
  },
  methods: {
    close(id) {
      this.$refs[`notification${id}`][0].classList.add('hidden');
    },
    formatDate(value) {
      return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/userData"];
    },
    notifications() {
      return this.$store.getters["auth/notifications"];
    },
  }
}
</script>

<style lang="scss">

.hidden {
  display: none;
}

.team {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 100px;

  .heading {
    margin-top: 52px;
    margin-bottom: 28px;

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 36px;
      line-height: 107.19%;
      color: #FFFFFF;

    }

  }

  .links {
    margin-bottom: 15px;

    a {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #FFFFFF;
      text-decoration: none;
      width: 79px;
      height: 79px;
      border: 2px solid #FFFFFF;
      box-sizing: border-box;
      border-radius: 50%;
      display: inline-grid;
      padding: 24px 10px;
      margin: 0 8px;
      background: unset;

      h4 {
        font-size: 14px;
        margin-bottom: 0;

      }

    }

    button {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #FFFFFF;
      text-decoration: none;
      width: 79px;
      height: 79px;
      border: 2px solid #FFFFFF;
      box-sizing: border-box;
      border-radius: 50%;
      display: inline-grid;
      padding: 24px 10px;
      margin: 0 8px;
      background: unset;

      h4 {
        font-size: 14px;
        margin-bottom: 0;

      }

    }

    .robitics, .music {
      @extend button;
      //background: radial-gradient(119.62% 119.62% at 108.23% 16.46%, #00C369 0%, rgba(0, 195, 105, 0) 100%);
      position: relative;

    }


  }

  .notifications {
    width: 61%;
    position: absolute;
    bottom: 0px;
    left: 19%;

    .col-md-3 {
      width: 21%;
    }


    .card {
      border-radius: 28px;
      margin: 0;
      padding: 0;
      border: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background: url('~@/assets/dashboard/img/unsplash_dKd3p6gha-c.png'), linear-gradient(86.73deg, #FFFFFF 19.23%, #C2C2C2 108.91%);
      box-shadow: 0px 11px 30px -3px rgba(0, 0, 0, 0.25);

      .close {
        position: absolute;
        right: 40px;
        top: 24px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 161%;
        color: #050505;
        transform: rotate(45deg);
        cursor: pointer;

      }

      .replay {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 98.3%;
        color: #FFFFFF;
        text-decoration: none;
        background: linear-gradient(90deg, #00FF85 0%, #003827 222.91%);
        border-radius: 4px;
        position: absolute;
        bottom: -10px;
        right: 45px;
        padding: 12px 79px;

      }

      img {
        width: 100%;
        height: 100%;

      }

      .card-body {
        text-align: left;
        padding: 23px 42px;

        h6 {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 161%;
          color: #050505;

        }

        .card-title {
          font-family: Roboto;
          font-style: normal;
          font-weight: 500;
          font-size: 24px;
          line-height: 161%;
          color: #050505;

        }

        .card-text {
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 18px;
          line-height: 150%;
          color: #000000;

        }
      }
    }


    @for $i from 1 through 3 {
      .card:nth-of-type(n + #{$i}) {
        left: ($i * 10px);
        top: ($i * 10px);
      }
    }


  }
}
</style>
